module.exports = __webpack_public_path__ + "static/media/sacolas.33d4afac.jpg";